<template>
<div class="chapter">
<div class="inner_page">
<div id="copyright">
<p><a id="page_4"></a>Copyright © 2016 by Susanna Harwood Rubin.</p>
<p>All rights reserved. No part of this book may be reproduced in any form without written permission from the publisher.</p>
<p>Library of Congress Cataloging-in-Publication Data available.</p>
<p>ISBN 978-1-4521-4500-6 (hc)<br/>ISBN 978-1-4521-5095-6 (epub, mobi)</p>
<p>Design by Allison Weiner<br/>Illustrations by Susanna Harwood Rubin</p>
<p>The information, practices, and poses in this book are not offered as medical advice or suggested as treatment for any condition that might require medical attention. To avoid injury, practice yoga with a skilled instructor and consult a health professional to determine your body’s needs and limitations. The writer and publisher hereby disclaim any liability from injuries resulting from following any recommendation in this book.</p>
<p>Chronicle Books LLC<br/>680 Second Street<br/>San Francisco, California 94107<br/><a href="http://www.chroniclebooks.com/" target="_blank"><span class="gray1">www.chroniclebooks.com</span></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04copyright.vue?3c47a596